import { amountSchemaFactory, Shape } from '@src/validations';
import { ChooseAmountFormData } from '../../components/amountStep';
import * as yup from 'yup';
import chooseAmountSchema from '@src/validations/schemas/chooseAmount';
import { MAXIMUM_AMOUNT_TO_SEND } from '@src/constants';

const validationSchema = (isUserVerified: boolean) =>
  yup.object().shape<Shape<Omit<ChooseAmountFormData, 'recentlyChangedProp'>>>({
    // sendAmount: amountSchemaFactory({
    //   type: 'send',
    //   currencyPath: 'sendCurrency',
    //   minValue: 10,
    //   maxValue: !isUserVerified ? 50 : MAXIMUM_AMOUNT_TO_SEND,
    //   errorType: !isUserVerified ? 'unverified' : 'verified'
    // }),
    sendAmount: isUserVerified
      ? amountSchemaFactory({
          type: 'send',
          currencyPath: 'sendCurrency',
          minValue: 1
          // minValue: 10
          // maxValue: MAXIMUM_AMOUNT_TO_SEND,
          // errorType: 'verified'
        })
      : yup
          .number()
          .test(
            'isUnverified',
            'To send money, please verify your account.',
            (value) => value === 0
          ),
    sendCountry: chooseAmountSchema.country,
    sendCurrency: chooseAmountSchema.currency,
    receiveAmount: amountSchemaFactory({
      type: 'receive',
      currencyPath: 'receiveCurrency',
      minValue: 1
      // minValue: 10
    }),
    receiveCountry: chooseAmountSchema.country,
    receiveCurrency: chooseAmountSchema.currency,
    recipientType: chooseAmountSchema.recipientType,
    rate: chooseAmountSchema.rate,
    totalAmount: yup.number(),
    totalAmountBackup: yup.number(),
    maximumTransactionAmount: yup.number(),
    remainingDailyTransactionAmount: yup.number(),
    remainingMonthlyTransactionAmount: yup.number()
  });
export default validationSchema;
